import { gql } from '@apollo/client';

export const GET_QUERY_HISTORY_LIST = gql`
  query ChatbotQueryHistoryList($params: FindChatbotQueryHistoryListInput!) {
    chatbotQueryHistoryList(params: $params) {
      success
      message
      errors
      data {
        histories {
          id
          tenantId
          userId
          query
          generatedSql
          prompt
          tablesUsed
          executionSuccess
          executionErrorMessage
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_QUERY_HISTORY = gql`
  query ChatbotQueryHistory($params: FindChatbotQueryHistory!) {
    chatbotQueryHistory(params: $params) {
      success
      message
      errors
      data {
        id
        tenantId
        userId
        query
        generatedSql
        prompt
        tablesUsed
        executionSuccess
        executionErrorMessage
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
